import { LoaderStyles } from "atoms/constants/loader-styles";
import Loader from "atoms/loaders/loader";
import { UserBookmarkCountBy } from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-by";
import UserBookmarkRecord from "models/view-models/user-bookmark-record";
import BookmarkCard from "organisms/my-link/my-bookmarks/bookmark-card";
import React from "react";
import { useHistory, useLocation } from "react-router";
import {
    BookmarkGroupNameFromCountByMap,
    BookmarkUtils,
} from "utilities/bookmark-utils";
import { CollectionUtils } from "utilities/collection-utils";
import { RouteUtils } from "utilities/route-utils";

interface AccordionBookmarkGridProps {
    bookmarks: UserBookmarkRecord[];
    isLoading: boolean;
    groupBy: UserBookmarkCountBy;
    panelId: string | number;
    observerRef: (node: any) => void;
    hasRecordsRemaining: boolean;
    gridColumn?: number;
    onClick?: (bookmark: UserBookmarkRecord) => void;
}

const CSS_CLASS_NAME = "c-accordion-bookmark-grid";

const AccordionBookmarkGrid = (props: AccordionBookmarkGridProps) => {
    const {
        bookmarks,
        isLoading,
        groupBy,
        panelId,
        hasRecordsRemaining,
        observerRef,
        gridColumn,
        onClick,
    } = props;
    const { search } = useLocation();
    const { push } = useHistory();

    const handleBookmarkClick = (bookmark: UserBookmarkRecord) => {
        if (onClick) {
            onClick(bookmark);
            return;
        }
        // Finds skip value based on position in list
        const skipValueForBookmark =
            Math.floor(
                (bookmarks.findIndex((b) => b.id === bookmark.id) ?? 1) / 10
            ) * 10;
        const skipParam = {
            [`skip_${BookmarkUtils.buildGroupedParam(groupBy, panelId)}`]:
                skipValueForBookmark,
        };

        // Adds skip to search params
        const paramsToAdd = {
            ...RouteUtils.queryStringToObject<{ [key: string]: string }>(
                search
            ),
            ...skipParam,
        };

        // Builds route
        const routeToDetailPage = BookmarkUtils.getDetailViewRoute(
            BookmarkGroupNameFromCountByMap[groupBy],
            panelId,
            bookmark.id!,
            RouteUtils.appendQueryParams("", paramsToAdd)
        );

        // Pushes to detail page
        push(routeToDetailPage);
    };

    const listStyle = (
        gridColumn ? { "--grid-column": gridColumn } : {}
    ) as React.CSSProperties;

    return (
        <div className={CSS_CLASS_NAME}>
            {isLoading ? (
                <Loader type={LoaderStyles.LinkGlyphGray} />
            ) : (
                <>
                    <ul className={`${CSS_CLASS_NAME}__list`} style={listStyle}>
                        {bookmarks?.map((bookmark) => (
                            <li
                                key={bookmark.id}
                                className={`${CSS_CLASS_NAME}__listItem`}>
                                <BookmarkCard
                                    bookmark={bookmark}
                                    collections={[]}
                                    inCollectionView={false}
                                    onBookmarkDeleted={() => {}}
                                    onBookmarkUpdated={() => {}}
                                    onClick={() =>
                                        handleBookmarkClick(bookmark)
                                    }
                                />
                            </li>
                        ))}
                        {CollectionUtils.hasValues(bookmarks) &&
                            hasRecordsRemaining && (
                                <div
                                    ref={observerRef}
                                    className={`${CSS_CLASS_NAME}__scrollEnd`}>
                                    <Loader type={LoaderStyles.LinkGlyphGray} />
                                </div>
                            )}
                    </ul>
                </>
            )}
        </div>
    );
};

export default AccordionBookmarkGrid;
